const importSessionsEndpoints = {
	RecordImportSession: {
		invalidatesTags: ["ImportSessions"] as AddTagTypes
	}
};

export default importSessionsEndpoints;
